import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button/standard-button';
import { token } from '@atlaskit/tokens';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import errorStateImage from '../../../assets/error-state.svg';
import messages from './messages';
import type { Props } from './types';

export const TableErrorView = (props: Props) => {
	const {
		intl: { formatMessage },
		onRefresh,
	} = props;
	return (
		<ImageWrapper data-testid="users-and-roles.ui.actors-table.table-error-view.wrapper">
			<img alt="Error screen" src={errorStateImage} />
			<HeaderWrapper>{formatMessage(messages.somethingWrong)}</HeaderWrapper>
			<TextWrapper>
				{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
				<span>{formatMessage(messages.pageLoadPrevented)}</span>
				{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
				<span>{formatMessage(messages.tryAgain)}</span>
			</TextWrapper>
			<div data-testid="users-and-roles.ui.actors-table.table-error-view.refresh">
				{/* @ts-expect-error - TS2322 - Type '{ children: string; externalId: string; onClick: () => void; }' is not assignable to type 'IntrinsicAttributes & ButtonProps & RefAttributes<HTMLElement>'. */}
				<Button externalId="users-and-roles.refresh-table-button" onClick={onRefresh}>
					{formatMessage(messages.refresh)}
				</Button>
			</div>
		</ImageWrapper>
	);
};

export default injectIntl(TableErrorView);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ImageWrapper = styled.div<{
	children?: ReactNode;
	['data-testid']: string;
}>({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	marginTop: token('space.500', '40px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TextWrapper = styled.div<{
	children?: ReactNode;
}>({
	margin: token('space.100', '8px'),
	display: 'flex',
	flexDirection: 'column',
	textAlign: 'center',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${gridSize * 40}px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HeaderWrapper = styled.h2<{
	children?: ReactNode;
}>({
	marginTop: token('space.300', '24px'),
});
